/**
 * Search Store Reset & Product Filtering
 * Resets search and filters products when store switcher changes
 */
(function() {
  'use strict';
  
  // Configuration
  const CONFIG = {
    redirectFromSearchPage: false,
    clearPredictiveSearch: true,
    updatePlaceholders: true,
    filterProducts: true,
    logActions: false  // ⭐ TURNED ON for debugging
  };
  
  // Utility function to check if store is "all brands"
  function isAllBrands(storeValue) {
    if (!storeValue) return false;
    const normalized = storeValue.toLowerCase().trim();
    return normalized === 'all brands';
  }
  
  function log(message) {
    if (CONFIG.logActions) {
      console.log('[Search & Filter]', message);
    }
  }
  
  // ⭐ CRITICAL: Handle external referrals IMMEDIATELY
  (function handleExternalReferrals() {
    const referrer = document.referrer;
    const currentDomain = window.location.hostname;
    const hasExternalReferrer = referrer && !referrer.includes(currentDomain);
    
    console.log('=== EXTERNAL REFERRAL CHECK ===');
    console.log('Referrer:', referrer);
    console.log('Current domain:', currentDomain);
    console.log('Has external referrer:', hasExternalReferrer);
    
    // Force "all brands" for external traffic
    if (hasExternalReferrer) {
      localStorage.setItem("store-selected", "all brands");
      // Also set HTML attribute immediately if DOM is ready
      if (document.documentElement) {
        document.documentElement.dataset.storeSelected = "all brands";
      }
      console.log('✓ External referrer detected - forced all brands');
    }
    
    console.log('Current store after check:', localStorage.getItem("store-selected"));
  })();
  
  function filterProductsOnPage() {
    if (!CONFIG.filterProducts) return;
    
    const selectedStore = localStorage.getItem("store-selected") || "all brands";
    
    // IMPORTANT: Don't run product filtering on product pages!
    if (window.location.pathname.includes('/products/')) {
      log('Skipping product filtering on product page');
      return;
    }
    
    log(`=== FILTERING PRODUCTS ===`);
    log(`Selected store: ${selectedStore}`);
    log(`Is all brands: ${isAllBrands(selectedStore)}`);
      
    // Find all product elements
    const productSelectors = [
      '.grid-product',
      '.product-item', 
      '.search-product',
      '[data-product-id]',
      '.product-grid-item',
      '.predictive-product-wrapper',
      '[data-vendor]'
    ];
    
    let allProducts = [];
    productSelectors.forEach(selector => {
      const products = document.querySelectorAll(selector);
      allProducts = allProducts.concat(Array.from(products));
    });
    
    // Remove duplicates
    allProducts = allProducts.filter((item, index, self) => 
      self.indexOf(item) === index
    );
    
    log(`Found ${allProducts.length} products to filter`);
    
    let visibleCount = 0;
    let hiddenCount = 0;
    
    // ⭐ CRITICAL: If "all brands" is selected, show EVERYTHING
    if (isAllBrands(selectedStore)) {
      log('ALL BRANDS selected - showing all products');
      allProducts.forEach((item) => {
        item.style.display = '';
        item.style.visibility = 'visible';
        item.style.opacity = '1';
        visibleCount++;
      });
      log(`✓ Showed all ${visibleCount} products`);
      return; // Exit early
    }
    
    // Only do filtering for specific brands
    log('Specific brand selected - filtering products');
    allProducts.forEach((item, index) => {
      let productVendor = '';
      
      // Try multiple ways to get vendor info
      if (item.dataset.vendor) {
        productVendor = item.dataset.vendor.toLowerCase();
      } else {
        const vendorElement = item.querySelector('.grid-product__vendor, [class*="vendor"]');
        if (vendorElement) {
          productVendor = vendorElement.textContent.trim().toLowerCase();
        } else {
          const itemText = item.textContent.toLowerCase();
          if (itemText.includes('oxygen') && !itemText.includes('quorum')) {
            productVendor = 'oxygen';
          } else if (itemText.includes('quorum') && !itemText.includes('oxygen')) {
            productVendor = 'quorum';
          }
        }
      }
      
      const shouldShow = productVendor === selectedStore.toLowerCase() || selectedStore === '';
      
      if (shouldShow) {
        item.style.display = '';
        visibleCount++;
        if (index < 3) log(`  ✓ Product ${index + 1}: vendor="${productVendor}" - SHOWING`);
      } else {
        item.style.display = 'none';
        hiddenCount++;
        if (index < 3) log(`  ✗ Product ${index + 1}: vendor="${productVendor}" - HIDING`);
      }
    });
    
    log(`Filter complete: ${visibleCount} visible, ${hiddenCount} hidden`);
    
    hideEmptyProductSections(visibleCount);
  }
  
  function hideEmptyProductSections(visibleCount) {
    const selectedStore = localStorage.getItem("store-selected") || "all brands";
    
    const productSections = document.querySelectorAll(
      '.results--products, [data-type-products], .product-grid, .search-results'
    );
    
    // Show all sections if "all brands" selected
    if (isAllBrands(selectedStore)) {
      productSections.forEach(section => {
        section.style.display = '';
      });
      return;
    }
    
    // Hide empty sections for specific brands
    productSections.forEach(section => {
      const hiddenProductsInSection = section.querySelectorAll('[style*="display: none"]').length;
      const totalProductsInSection = section.querySelectorAll('.grid-product, .product-item, .predictive-product-wrapper').length;
      
      if (totalProductsInSection > 0 && hiddenProductsInSection === totalProductsInSection) {
        section.style.display = 'none';
      } else if (totalProductsInSection > 0) {
        section.style.display = '';
      }
    });
  }
  
  function resetSearchInputs() {
    log('Resetting search inputs');
    
    const searchInputs = document.querySelectorAll('input[type="search"], input[name="q"]');
    searchInputs.forEach(input => {
      input.value = '';
    });
    
    if (CONFIG.clearPredictiveSearch) {
      const predictiveContainer = document.getElementById('predictive-search');
      if (predictiveContainer) {
        predictiveContainer.innerHTML = '';
        predictiveContainer.style.display = 'none';
      }
    }
    
    const searchOverlay = document.querySelector('.search-overlay, .predictive__screen');
    if (searchOverlay) {
      searchOverlay.style.display = 'none';
    }
    
    if (CONFIG.updatePlaceholders) {
      updateSearchPlaceholders();
    }
    
    filterProductsOnPage();
    
    if (window.location.pathname.includes('/search')) {
      if (CONFIG.redirectFromSearchPage) {
        log('Redirecting from search page');
        window.location.href = '/';
      }
    }
  }
  
  function updateSearchPlaceholders() {
    const selectedStore = localStorage.getItem("store-selected") || "all brands";
    const searchInputs = document.querySelectorAll('input[type="search"], input[name="q"]');
    
    searchInputs.forEach(input => {
      let placeholder = 'Search all products';
      
      if (selectedStore && !isAllBrands(selectedStore)) {
        const capitalizedStore = selectedStore.charAt(0).toUpperCase() + selectedStore.slice(1);
        placeholder = `Search ${capitalizedStore} products...`;
      }
      
      input.placeholder = placeholder;
    });
  }
  
  function updateFormVendorFilters() {
    const selectedStore = localStorage.getItem("store-selected") || "all brands";
    const searchForms = document.querySelectorAll('form[action*="search"]');
    
    searchForms.forEach(form => {
      const vendorInput = form.querySelector('input[name="filter.p.vendor"], .vendor-filter-input');
      if (vendorInput) {
        if (selectedStore && !isAllBrands(selectedStore)) {
          const capitalizedStore = selectedStore.charAt(0).toUpperCase() + selectedStore.slice(1);
          vendorInput.value = capitalizedStore;
        } else {
          vendorInput.value = '';
        }
      }
    });
  }
  
  function isStoreRadio(element) {
    return (
      element.matches('store-switcher input[type="radio"]') || 
      (element.type === 'radio' && element.closest('store-switcher')) ||
      (element.type === 'radio' && element.name && element.name.startsWith('store-switcher-'))
    );
  }
  
  function handleStoreChange() {
    log('Store changed - executing reset and filter');
    updateFormVendorFilters();
    
    if (!window.location.pathname.includes('/products/')) {
      setTimeout(resetSearchInputs, 100);
    } else {
      log('Skipping search reset on product page');
      if (CONFIG.updatePlaceholders) {
        updateSearchPlaceholders();
      }
    }
  }
  
  function initializeSearchReset() {
    log('Initializing search reset and product filtering');
    
    document.addEventListener('change', function(e) {
      if (isStoreRadio(e.target)) {
        handleStoreChange();
      }
    });
    
    document.addEventListener('click', function(e) {
      const storeLabel = e.target.closest('store-switcher label');
      if (storeLabel) {
        setTimeout(handleStoreChange, 150);
      }
    });
    
    document.addEventListener('storeChanged', function(e) {
      log(`Store changed via custom event: ${e.detail.selectedStore}`);
      handleStoreChange();
    });
    
    // ⭐ INCREASED DELAY - wait for products to render
    setTimeout(function() {
      if (!window.location.pathname.includes('/products/')) {
        log('Running initial setup');
        updateSearchPlaceholders();
        updateFormVendorFilters();
        filterProductsOnPage();
      }
    }, 500); // Increased from 100ms to 500ms
    
    log('All event listeners attached');
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSearchReset);
  } else {
    initializeSearchReset();
  }
  
  window.SearchStoreReset = {
    config: CONFIG,
    reset: resetSearchInputs,
    filterProducts: filterProductsOnPage,
    updatePlaceholders: updateSearchPlaceholders,
    updateForms: updateFormVendorFilters,
    isAllBrands: isAllBrands,
    debug: {
      showAllProducts: () => {
        document.querySelectorAll('.grid-product, .product-item, [data-vendor]')
          .forEach(p => p.style.display = '');
        console.log('Debug: Forced all products visible');
      },
      getCurrentStore: () => localStorage.getItem("store-selected"),
      testAllBrands: (value) => isAllBrands(value)
    }
  };
  
})();